import styled from 'styled-components';

export const WhatsappButton = styled.button`
  position: fixed;
  bottom: 2.5rem;
  left: 2.5rem;
  z-index: 10;

  background: transparent;
  border: none;
  filter: ${({ theme }) =>
    `drop-shadow(0 0 0.8rem ${theme.colors.modalBackground});`};
`;
